import ICreateAccountResponse from "../models/createAccount/ICreateAccountResponse";

export default function createCreateAccountResponseFromJSON(json: object = {}): ICreateAccountResponse{
  return json as ICreateAccountResponse;
}